module.exports = __webpack_public_path__ + "media/src/assets/images/e-commerce-industry-b66f99add8d08648966a2e1da1f23ab6.svg";